import { SearchService } from '@lib/constants/variants';
import { useSearchService } from '@lib/context/search-service-context';
import Image from 'next/image';

export const SearchServiceLogo = () => {
    const searchService = useSearchService();
    if (!searchService?.currentSearch) return;
    return (
        <>
            {searchService.currentSearch === SearchService.GOOGLE ?
                <Image src={'/google.png'} width="76" height="27" alt="" className='pt-1 inline-block align-middle' /> :
                <Image src={'/yelp.svg'} width="76" height="27" alt="" />
            }
        </>
    )
}